<template>
  <q-card>
    <q-card-section
      ><q-icon name="smartphone" />
      <div class="text-h6">SMS Icerikleri</div>
    </q-card-section>
    <q-card-section>
      Sistemin gonderecegi SMS icin icerik olusturma.
    </q-card-section>
    <q-card-section class="q-pt-none">
      <q-form class="q-gutter-md">
        <!-- Appointment Created -->
        <q-input
          v-model="appointmentCreated"
          type="textarea"
          filled
          label="Yeni randevu"
          :rules="[(val) => (val && val.length > 0) || 'Bos olamaz']"
        />

        <!-- Appointment Cancelled -->
        <q-input
          v-model="appointmentCancelled"
          type="textarea"
          filled
          label="Iptal edilen randevu"
          lazy-rules
          :rules="[(val) => (val && val.length > 0) || 'Bos olamaz']"
        />

        <!-- Appointment ReScheduled -->
        <q-input
          v-model="appointmentReScheduled"
          type="textarea"
          filled
          label="Saati degisen randevu"
          lazy-rules
          :rules="[(val) => (val && val.length > 0) || 'Bos olamaz']"
        />
      </q-form>
    </q-card-section>

    <q-card-actions align="right" class="text-primary">
      <q-btn label="Kaydet" color="secondary" @click="onSubmit" />
    </q-card-actions>
  </q-card>
</template>

<script>
import { useQuasar } from 'quasar'
import { ref } from 'vue'
import axios from 'axios'
import * as notify from '../../utils/notification'
import * as constants from '../../utils/settings'

export default {
  props: {},
  setup() {
    const $q = useQuasar()

    // form inputs
    const appointmentCreated = ref(null)
    const appointmentCancelled = ref(null)
    const appointmentReScheduled = ref(null)

    function getSmsTemplates() {
      axios.get('/settings/smstemplate').then((response) => {
        appointmentCreated.value =
          response.data[constants.SETTINGS_SMS_TEMPLATE_CREATED_BODY]
        appointmentReScheduled.value =
          response.data[constants.SETTINGS_SMS_TEMPLATE_RESCHEDULED_BODY]
        appointmentCancelled.value =
          response.data[constants.SETTINGS_SMS_TEMPLATE_CANCELLED_BODY]
      })
    }
    getSmsTemplates()
    return {
      appointmentCreated,
      appointmentCancelled,
      appointmentReScheduled,

      onSubmit() {
        axios
          .post('/settings/smstemplate', {
            [constants.SETTINGS_SMS_TEMPLATE_CREATED_BODY]:
              appointmentCreated.value,
            [constants.SETTINGS_SMS_TEMPLATE_RESCHEDULED_BODY]:
              appointmentReScheduled.value,
            [constants.SETTINGS_SMS_TEMPLATE_CANCELLED_BODY]:
              appointmentCancelled.value,
          })
          .then(() => {
            $q.notify(notify.success('Mail icerikleri degistirildi.'))
            getSmsTemplates()
          })
          .catch(() => {
            $q.notify(notify.warning('Mail icerikleri degistirilemedi.'))
          })
      },
    }
  },
}
</script>
